import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  // Aseguramos que el JS de Bootstrap funcione correctamente
  useEffect(() => {
    // Inicializa los dropdowns de Bootstrap
    if (window.bootstrap && window.bootstrap.Dropdown) {
      document.querySelectorAll('.dropdown-toggle').forEach(element => {
        new window.bootstrap.Dropdown(element);
      });
    }
  }, []);

  return (
    <>
      <div className="navbar-top-bar"></div>
      <nav className="navbar navbar-expand-lg">
        <div className="container-fluid">
          <a className="navbar-brand d-flex align-items-center" href="/">
            <img src="/images/logo.png" alt="Logo" height="86" className="me-2" style={{ maxHeight: '86px' }} />
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNavDropdown" aria-controls="navbarNavDropdown" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNavDropdown">
            <ul className="navbar-nav">
              <li className="nav-item">
                <Link className="nav-link" to="/licitaciones/buscar">LICITACIONES</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard">DASHBOARD DE ANÁLISIS</Link>
              </li>
              <li className="nav-item">
                <Link className="nav-link" to="/dashboard/powerbi">POWER BI</Link>
              </li>
            </ul>
            <ul className="navbar-nav ms-auto">
              <li className="nav-item d-flex align-items-center">
                <a href="https://trainingcorpltda.sharepoint.com/sites/InnTraining2" className="btn btn-intranet">Intranet</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}

export default Navbar;
